import { track } from './analytics';

export type UpgradeTrigger = 'credits' | 'locked_feature' | 'trial_ending' | 'organic';

export function trackUpgradeCta(location: string, trigger: UpgradeTrigger, feature?: string) {
  track('upgrade_cta_clicked', {
    cta_location: location,
    trigger,
    ...(feature && { feature: feature.trim().toLowerCase().replace(/\W+/g, '_') }),
  });
}

// Sent with sendBeacon: checkout navigates away right after.
export function trackCheckoutStarted(plan: {
  id: string;
  price: { amount: number; currency: string };
}) {
  track(
    'checkout_started',
    { plan: plan.id, price: plan.price.amount / 100, currency: plan.price.currency },
    { transport: 'sendBeacon' }
  );
}
